const BASE_URL = "https://api.artsy.net/api";

async function handleResponse(response) {
  if (!response.ok) {
    throw new Error("HTTP Error");
  }
  return await response.json();
}


//extract artist name and tidy up the title
function extractArtistAndTitle(originalTitle) {
  const match = originalTitle.match(/^([^,]+),\s*(.*)/); //match artist, title (one hour of my life i'll never get back)
  return {
    artistName: match ? match[1] : "Unknown",
    cleanTitle: match ? match[2] : originalTitle,
  };
}

//authenticate and get XAPP token
export async function authenticate() {
  const url = `${BASE_URL}/tokens/xapp_token`;
  const body = {
    client_id: import.meta.env.VITE_ARTSY_CLIENT_ID,
    client_secret: import.meta.env.VITE_ARTSY_CLIENT_SECRET,
  };

  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  return handleResponse(response).then((data) => data.token);
}

//fetch search results, extract artist name, and clean title
export async function searchArtworks(query, token, offset = 0, size = 10) {
  const searchUrl = `${BASE_URL}/search?q=${encodeURIComponent(query)}&size=${size}&offset=${offset}&type=artwork&total_count=1`;

  const response = await fetch(searchUrl, {
    method: "GET",
    headers: {
      "X-XAPP-Token": token,
      "Accept": "application/json",
    },
  });

  const data = await handleResponse(response);
  const artworks = data._embedded.results.filter((item) => item.type === "artwork");

  return {
    artworks: artworks.map((artwork) => {
      const { artistName, cleanTitle } = extractArtistAndTitle(artwork.title || "Untitled");
      return {
        title: cleanTitle,
        artistName: artistName,
        image: artwork._links.thumbnail?.href || null,
      };
    }),
    hasNextPage: Boolean(data._links.next),
    totalCount: data.total_count || 0,
  };
}

export async function getRandomArtworks(token, size, offset) {
  const url = `${BASE_URL}/artworks?size=${size}&offset=${offset}`;
  const response = await fetchWithRetry(url, {
    method: "GET",
    headers: {
      "X-XAPP-Token": token,
      "Accept": "application/json",
    },
  });

  const data = await handleResponse(response);
  const artworks = data._embedded.artworks;


  return artworks.map((artwork) => ({
    title: artwork.title,
    artistName: "Unknown Artist", 
    date: artwork.date,
    image: artwork._links.image.href.replace("{image_version}", "large"),
  }));
}

//fix for 429
async function fetchWithRetry(url, options, retries = 3, delay = 1000) {
  for (let i = 0; i < retries; i++) {
    const response = await fetch(url, options);
    if (response.ok || response.status !== 429) {
      return response; 
    }
    await new Promise((resolve) => setTimeout(resolve, delay)); 
  }
  throw new Error("too many requests, all retries used");
}


